// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Dashboard Container */
.admin-dashboard-container {
    display: flex;
    /* max-width: 1440px;  */
    margin: 0 auto;
    padding: 3rem; 
    /* background-color: var(--clr-primary-6); */
    background-color: var(--clr-grey-10);
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    transition: var(--transition);
    flex-direction: column; 
    animation: fadeIn 0.5s ease-in-out;
    overflow: hidden; 
}

/* Sidebar */
/* Sidebar Container */
.sidebar {
    flex: 0 0 280px;
    background-color: var(--clr-white);
    padding: 1.5rem 1rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    margin-right: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    height: 100vh;
    overflow-y: auto;
}

/* Sidebar Heading */
.sidebar h3 {
    font-size: 1.4rem;
    font-weight: bold;
    color: var(--clr-dark);
    margin-bottom: 1rem;
    text-align: center;
    border-bottom: 2px solid var(--grey-200); 
    padding-bottom: 0.5rem;
}

/* Discipline Button */
.discipline-button {
    background-color: var(--clr-primary-2); 
    color: var(--clr-white);
    padding: 0.75rem;
    width: 100%;
    border-radius: var(--radius);
    font-size: 1.2rem;
    font-weight: 600;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--shadow-1);
    margin-bottom: 0.4rem;
    position: relative; 
}

/* Selected Discipline */
.discipline-button.selected {
    background-color: var(--clr-primary-6); 
    color: var(--clr-white);
    box-shadow: var(--shadow-2);
}

/* Discipline Button Hover */
.discipline-button:hover {
    background-color: var(--clr-primary-4);
    transform: translateY(-2px);
}

/* Optional Indicator Arrow/Icon */
.discipline-button::after {
    content: '▸'; 
    font-size: 1.2rem;
    color: var(--clr-white);
    position: absolute;
    right: 1rem;
    transform: rotate(90deg);
    transition: transform 0.3s ease;
}

/* Change arrow when selected */
.discipline-button.selected::after {
    transform: rotate(-90deg); 
}

/* Doctor List */
.doctor-list {
    padding-left: 1.5rem;
    margin-top: 0.4rem;
    display: flex;
    flex-direction: column;
    gap: 0.4rem; 
    border-left: 2px solid var(--clr-primary-4); 
}

/* Doctor Button */
.doctor-button {
    background-color: var(--grey-100);
    color: var(--clr-grey-1);
    padding: 0.6rem 1rem;
    border-radius: var(--radius);
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: var(--shadow-1);
    position: relative;
}

/* Hover Effect for Doctor */
.doctor-button:hover {
    background-color: var(--grey-300);
    transform: translateX(5px); 
    box-shadow: var(--shadow-2);
}

/* Selected Doctor */
.doctor-button.selected {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
    box-shadow: var(--shadow-2);
}

/* Responsive Design */
@media (max-width: 768px) {
    .sidebar {
        width: 100%;
        margin-right: 0;
        padding: 1rem;
    }

    .discipline-button, .doctor-button {
        font-size: 1rem;
    }
}


/* Flexibility for larger screens */
@media (min-width: 768px) {
    .admin-dashboard-container {
        flex-direction: row; 
    }
}

/* Sidebar headings */
.sidebar h3 {
    font-size: 1.4rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: var(--clr-grey-1);
}

.discipline-section {
    margin-bottom: 1.5rem;
}

.discipline-button {
    width: 100%;
    padding: 0.75rem;
    border: none;
    border-radius: var(--radius);
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    cursor: pointer;
    text-align: left;
    font-size: 1rem;
    font-weight: 500;
    transition: var(--transition);
}

.discipline-button:hover {
    background-color: var(--clr-primary-3);
    box-shadow: var(--shadow-3);
}

.doctor-list {
    margin-top: 1rem;
}

.doctor-button {
    display: block;
    width: 100%;
    padding: 0.5rem;
    border: none;
    background-color: var(--clr-grey-10);
    color: var(--clr-grey-2);
    border-radius: var(--radius);
    margin-bottom: 0.5rem;
    cursor: pointer;
    text-align: left;
    font-size: 1rem;
    transition: var(--transition);
}

.doctor-button.selected {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
}

.doctor-button:hover {
    background-color: var(--clr-primary-6);
    color: var(--clr-white);
    box-shadow: var(--shadow-3);
}

/* Main Dashboard Section */
/* .main-dashboard {
    flex: 1;
    padding-left: 20px;
} */

.main-dashboard {
    flex: 1 1;
    padding-left: 30px; 
    min-height: 100vh; 
    overflow-y: auto; 
}


/* Controls Section */
.admin-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
}

.admin-filter {
    display: flex;
    gap: 1rem;
}

.admin-filter button {
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: var(--radius);
    background-color: var(--clr-grey-3);
    color: var(--clr-white);
    cursor: pointer;
    transition: var(--transition);
}

.admin-filter button.active {
    background-color: var(--clr-primary-3);
}

.admin-filter button:hover {
    background-color: var(--clr-primary-3);
    transform: translateY(-2px);
}

/* Search Section */
.admin-search input {
    padding: 0.75rem;
    width: 250px;
    border: 1px solid var(--grey-300);
    border-radius: var(--radius);
    outline: none;
    transition: var(--transition);
}

.admin-search input:focus {
    border-color: var(--clr-primary-5);
}

/* Calendar Section */
.admin-calendar {
    background-color: #ffffff; 
    border-radius: var(--radius);
    box-shadow: var(--shadow-3); 
    padding: 2rem;
    margin-bottom: 2rem;
}

/* Responsive Styling */
@media (max-width: 768px) {
    .admin-controls {
        flex-direction: column; 
        align-items: stretch; 
        gap: 1rem;
    }

    .admin-filter {
        flex-direction: column; 
        align-items: stretch; 
    }

    .admin-filter button {
        padding: 0.5rem 1rem; 
        font-size: 0.875rem; 
    }

    .admin-search input {
        width: 100%; 
        padding: 0.5rem;
    }

    .admin-calendar {
        padding: 1rem; 
        margin-bottom: 1rem;
    }
}

@media (max-width: 480px) {
    .admin-filter button {
        padding: 0.5rem 0.75rem; 
        font-size: 0.75rem; 
    }

    .admin-search input {
        width: 100%; 
        padding: 0.5rem;
    }

    .admin-calendar {
        padding: 0.75rem; 
    }
}


/* Calendar Event Buttons with Linear Gradient */
.rbc-event {
    padding: 0.5rem;
    border-radius: var(--radius);
    color: var(--clr-white);
    background: linear-gradient(135deg, #48a9a6, #82b74b); 
    transition: var(--transition);
    box-shadow: var(--shadow-2);
}

.rbc-event:hover {
    transform: scale(1.05);
    box-shadow: var(--shadow-3);
}

/* Admin Appointments Container */
.admin-appointments-container {
    background-color: var(--clr-white);
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    margin-top: 2rem;
    position: relative;
    flex-direction: column; 
}

/* Container for search and sort */
.search-sort-container {
    display: flex; 
    align-items: center; 
    gap: 1rem; 
    margin-bottom: 1rem;
}

/* Search Section */
.search-section input {
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--clr-primary-6);
    width: 250px;
    outline: none;
}

.search-section input:focus {
    border-color: var(--clr-primary-5);
}

/* Sorting Section */
.sort-section select {
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--clr-primary-6);
    font-size: 1rem;
    background-color: var(--clr-white);
}


/* Appointment List Styling */
.admin-appointments-list {
    max-height: 400px;
    overflow-y: auto;
    list-style: none;
    padding: 1rem;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

/* List item styles */
.admin-appointments-list li {
    padding: 1.25rem;
    background-color: var(--grey-100);
    margin-bottom: 1rem;
    border-radius: var(--radius);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: var(--shadow-1);
    transition: var(--transition);
    width: 100%;
}

.admin-appointments-list li:hover {
    background-color: var(--grey-200);
}

/* Scrollbar styling */
.admin-appointments-list::-webkit-scrollbar {
    width: 8px;
}

.admin-appointments-list::-webkit-scrollbar-thumb {
    background-color: var(--clr-primary-5);
    border-radius: 4px;
}

.admin-appointments-list li strong {
    font-size: 1.1rem;
    color: var(--clr-grey-2);
}

/* No Appointments Found */
.no-appointments {
    text-align: center;
    padding: 2rem;
    font-size: 1.2rem;
    color: var(--clr-grey-5);
}

/* Action Buttons */
.admin-appointment-actions {
    display: flex;
    gap: 0.75rem;
}

.approve-btn, .cancel-btn, .view-btn {
    min-width: 100px;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: var(--radius);
    font-size: 0.9rem;
    cursor: pointer;
    transition: var(--transition);
}

.approve-btn {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
}

.cancel-btn {
    background-color: var(--red-dark);
    color: var(--clr-white);
}

.view-btn {
    background-color: var(--clr-primary-4);
    color: var(--clr-white);
}

.approve-btn:hover {
    background-color: var(--clr-primary-3);
    transform: translateY(-2px);
}

.cancel-btn:hover {
    background-color: var(--red-dark);
    transform: translateY(-2px);
}

.view-btn:hover {
    background-color: var(--clr-primary-2);
    transform: translateY(-2px);
}
/* Pagination Controls */
.pagination-controls {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
}

.pagination-controls button {
    background-color: var(--grey-100);
    border: none;
    color: var(--grey-500);
    padding: 0.5rem 1rem;
    border-radius: var(--radius);
    cursor: pointer;
    margin: 0 0.25rem;
    transition: var(--transition);
}

.pagination-controls button:hover {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
}

.pagination-controls button:disabled {
    background-color: var(--grey-300);
    cursor: not-allowed;
}

/* Modal Overlay */
.modal-custom-admin {
    position: fixed;
    z-index: 1000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* Modal Content Box */
  .modal-content-custom-admin {
    background: var(--clr-white);
    padding: 2rem 2.5rem;
    border-radius: var(--radius);
    width: 800px;
    max-width: 95%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    animation: slideIn 0.3s ease-out;
  }
  
  /* Title */
  .modal-content-custom-admin h3 {
    font-size: 1.5rem;
    color: var(--clr-primary-4);
    margin-bottom: 1.5rem;
    text-align: center; 
  }
  
  /* Form Field Labels */
  .modal-content-custom-admin label {
    font-weight: 600;
    color: var(--clr-grey-2);
    display: block;
    margin-bottom: 0.5rem;
  }
  
  /* Dropdown & Fee */
  .modal-content-custom-admin select,
  .modal-content-custom-admin input {
    width: 100%;
    padding: 0.75rem;
    border-radius: var(--radius);
    border: 1px solid var(--grey-300);
    margin-bottom: 1.5rem;
    font-size: 1rem;
  }
  
  /* Button Container */
  .modal-btns-admin {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1rem;
  }
  
  /* Unified Button Base */
.close-btn-admin,
.view-intake-btn-admin {
  padding: 0.6rem 1.25rem;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: var(--radius);
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

/* Specific Styles */
.close-btn-admin {
  background-color: var(--grey-400);
  color: var(--clr-white);
}
.close-btn-admin:hover {
  background-color: var(--grey-500);
}

.view-intake-btn-admin {
  background-color: var(--clr-primary-5);
  color: var(--clr-grey-10);
}
.view-intake-btn-admin:hover {
  background-color: var(--clr-primary-6);
  transform: translateY(-1px);
}
.view-intake-btn-admin:active {
  transform: scale(0.98);
}

  /* Confirm Button */
  .confirm-payment-btn-admin {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    padding: 0.6rem 1.25rem;
    border-radius: var(--radius);
    font-size: 0.95rem;
    cursor: pointer;
  }
  
  .confirm-payment-btn-admin:hover {
    background-color: var(--clr-primary-3);
  }
  
  .payment-breakdown {
    background-color: var(--grey-100);
    padding: 1rem;
    border-radius: var(--radius);
    margin-bottom: 1.5rem;
    border-left: 4px solid var(--clr-primary-5);
    box-shadow: var(--shadow-1);
  }
  
  .payment-breakdown p {
    margin: 0.5rem 0;
    font-size: 1rem;
    color: var(--clr-grey-2);
  }
  
  .payment-breakdown strong {
    color: var(--clr-grey-1);
  }
  
  /* Animation */
  @keyframes slideIn {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }
  
  .invoice-preview-box-admin {
    background-color: var(--grey-100);
    padding: 1.25rem;
    border-radius: var(--radius);
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    border-left: 4px solid var(--clr-primary-4);
    box-shadow: var(--shadow-1);
  }
  
  .invoice-preview-box-admin h4 {
    margin-bottom: 1rem;
    color: var(--clr-primary-4);
    font-size: 1.1rem;
    text-align: left;
  }
  
  .invoice-summary-admin p {
    margin: 0.4rem 0;
    font-size: 1rem;
    color: var(--clr-grey-2);
  }
  
  .invoice-summary-admin strong {
    color: var(--clr-grey-1);
  }
  
  /* Collapsible toggle button */
.invoice-preview-toggle-btn {
    display: inline-block;
    background-color: var(--clr-primary-4);
    color: var(--clr-white);
    font-size: 0.95rem;
    font-weight: 500;
    padding: 0.5rem 1rem;
    border-radius: var(--radius);
    border: none;
    cursor: pointer;
    margin: 1rem 0;
    transition: background-color 0.3s ease;
  }
  
  .invoice-preview-toggle-btn:hover {
    background-color: var(--clr-primary-5);
  }
  
  /* Collapsible container */
  .invoice-preview-collapsible {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.4s ease;
  }
  
  .invoice-preview-collapsible.open {
    max-height: 600px; /* enough space for the content */
    overflow-y: auto;
    margin-top: 1rem;
  }

  /* Matched input & dropdown styles inside InvoicePreview */
.invoice-preview-box-admin label {
  font-weight: 600;
  margin: 0.5rem 0 0.25rem;
  color: var(--clr-grey-1);
  display: block;
  font-size: 0.95rem;
}

.invoice-preview-box-admin input[type="text"],
.invoice-preview-box-admin select {
  width: 100%;
  padding: 0.45rem 0.75rem;
  font-size: 0.95rem;
  border: 1px solid var(--clr-grey-8);
  border-radius: var(--radius);
  background-color: var(--clr-white);
  color: var(--clr-grey-1);
  margin-bottom: 1rem;
  transition: border-color 0.2s ease;
}

/* Style for react-select inside invoice box */
.invoice-preview-box-admin .react-select__control {
  width: 100%;
  font-size: 0.95rem;
  border-radius: var(--radius);
  background-color: var(--clr-white);
  border: 1px solid var(--clr-grey-8);
  box-shadow: none;
  transition: border-color 0.2s ease;
  margin-bottom: 1rem;
}

.invoice-preview-box-admin .react-select__control--is-focused {
  border-color: var(--clr-primary-5);
  box-shadow: 0 0 0 1px var(--clr-primary-5);
}

.invoice-preview-box-admin .react-select__value-container {
  padding: 0.25rem 0.5rem;
}

.invoice-preview-box-admin .react-select__input {
  color: var(--clr-grey-1);
}

.invoice-preview-box-admin .react-select__menu {
  font-size: 0.95rem;
  z-index: 20;
}

.invoice-preview-box-admin .react-select__option {
  padding: 0.5rem;
}

.invoice-preview-box-admin .react-select__option--is-focused {
  background-color: var(--clr-primary-10);
}

.invoice-preview-box-admin .react-select__option--is-selected {
  background-color: var(--clr-primary-5);
  color: white;
}

.invoice-preview-box-admin input[type="text"]:focus,
.invoice-preview-box-admin select:focus {
  border-color: var(--clr-primary-5);
  outline: none;
}

/* Tooltip Styling */
.react-tooltip {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 0.5rem;
    border-radius: var(--radius);
    font-size: 0.875rem;
}

/* Responsive Styling */
@media (max-width: 768px) {
    .admin-dashboard-container {
        flex-direction: column;
        padding: 1rem;
    }


    .sidebar {
        flex: 1 1;
        margin-right: 0;
        margin-bottom: 1.5rem;
        padding: 1rem;
    }

    .main-dashboard {
        padding-left: 0;
        width: 100%;
    }

    .admin-controls {
        flex-direction: column;
        gap: 1rem;
    }

    .admin-search input {
        width: 100%;
    }

    .admin-appointments-list {
        max-height: 300px;
        padding: 1rem;
        overflow-y: auto;
    }

    .admin-appointments-list li {
        flex-direction: column;
        align-items: flex-start;
    }

    .admin-appointment-actions {
        margin-top: 0.75rem;
        width: 100%;
        justify-content: flex-end;
    }

    .pagination-controls {
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
    }

    .calendar-controls {
        flex-direction: column;
    }

    /* Calendar adjustments for mobile */
    .admin-calendar {
        background-color: #ffffff; 
        box-shadow: var(--shadow-3);
        margin-bottom: 2rem;
        max-width: 100%;
    }

    /* Calendar Event Buttons with Linear Gradient */
.rbc-event {
    padding: 0.5rem;
    border-radius: var(--radius);
    color: var(--clr-white);
    background: linear-gradient(135deg, #48a9a6, #82b74b); 
    transition: var(--transition);
    box-shadow: var(--shadow-2);
}

.rbc-event:hover {
    transform: scale(1.05);
    box-shadow: var(--shadow-3);
}

    /* Modal adjustments */
    .modal-content-custom {
        width: 90%;
        max-width: 350px;
    }
}

/* Override the white-space: nowrap for .rbc-btn-group */
.rbc-btn-group {
    white-space: normal !important; /* Force normal white-space behavior to allow wrapping */
}

.loading-indicator {
    text-align: center;
    font-size: 1.2rem;
    color: var(--clr-primary-5);
    margin: 1rem 0;
  }
  
  .loading-indicator::after {
    content: '...';
    animation: dots 1.5s steps(3, end) infinite;
  }
  
  @keyframes dots {
    0%, 20% { content: '.'; }
    40% { content: '..'; }
    60%, 100% { content: '...'; }
  }
  


  /* Split the Required Action section into two columns */
.admin-appointments-container.split-layout {
    display: flex;
    flex-direction: row;
    gap: 2rem;
    justify-content: space-between;
    align-items: flex-start;
  }
  
  /* Left Column: Booked Appointments */
  .admin-appointments-list.booked-section {
    flex: 1 1;
    background-color: var(--grey-100);
    border-radius: var(--radius);
    padding: 1rem;
    box-shadow: var(--shadow-1);
  }
  
  /* Right Column: Completed Appointments */
  .admin-appointments-list.completed-section {
    flex: 1 1;
    background-color: var(--grey-100);
    border-radius: var(--radius);
    padding: 1rem;
    box-shadow: var(--shadow-1);
    max-height: 400px;
    overflow-y: auto;
  }
  
  /* Card style for completed tasks */
  .completed-card {
    background-color: var(--clr-white);
    border: 1px solid var(--grey-300);
    border-left: 4px solid var(--clr-success-dark); /* Green left border for CO */
    border-radius: var(--radius);
    padding: 1rem;
    margin-bottom: 1rem;
    box-shadow: var(--shadow-1);
    transition: var(--transition);
  }
  
  .completed-card:hover {
    background-color: var(--grey-200);
    transform: translateY(-2px);
  }
  
  .completed-card h4 {
    margin-bottom: 0.5rem;
    color: var(--clr-grey-1);
  }
  
  .completed-card p {
    margin-bottom: 0.75rem;
    font-size: 1rem;
    color: var(--clr-grey-1);
  }
  
  
  .confirm-payment-btn {
    margin-top: 0.75rem;
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 0.5rem 1rem;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
  }
  
  .confirm-payment-btn:hover {
    background-color: var(--clr-primary-3);
  }
  
  /* Responsive fix: stack vertically */
  @media (max-width: 1024px) {
    .admin-appointments-container.split-layout {
      flex-direction: column;
    }
  
    .admin-appointments-list.booked-section,
    .admin-appointments-list.completed-section {
      width: 100%;
    }
  }
  
  /* .cancel-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .approve-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  } */

  
  .download-invoice-btn-admin {
    background-color: var(--clr-primary-4);
    color: white;
    padding: 0.6rem 1.25rem;
    border: none;
    border-radius: var(--radius);
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .download-invoice-btn-admin:hover {
    background-color: var(--clr-primary-5);
  }
  
.download-invoice-btn-admin:disabled,
.confirm-payment-btn-admin:disabled {
  background-color: var(--grey-300) !important;
  color: var(--clr-grey-6) !important;
  cursor: not-allowed !important;
  opacity: 0.65;
  box-shadow: none;
  transform: none;
  pointer-events: auto; /* So tooltips (if added) still work */
}

/* Optional: remove hover color changes when disabled */
.download-invoice-btn-admin:disabled:hover,
.confirm-payment-btn-admin:disabled:hover {
  background-color: var(--grey-300) !important;
}

.invoice-hint-text {
  font-size: 0.92rem;
  color: #d97706; 
  margin: 0.5rem 0 0.75rem;
  font-style: italic;
}

.corner-ribbon-v2 {
  position: absolute;
  top: 10px;
  left: -35px;
  width: 140px;
  text-align: center;
  background: linear-gradient(135deg, #ff6b6b, #ffa600); 
  color: white;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 6px 0;
  transform: rotate(-45deg);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25); 
  z-index: 5;
  pointer-events: none;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border: 2px solid #fff3e0; 
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}


.modal-content-custom-admin {
  position: relative;
  /* overflow: visible; */
}

.room-highlight {
  display: inline-block;
  background-color: #ffebee;  
  color: #b71c1c;  
  padding: 0.35rem 0.75rem;
  border-left: 4px solid #e53935; 
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0.4rem 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.insurance-hint-text {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  font-style: italic;
  color: #d97706
}


.zero-insurance-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.zero-insurance-modal {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  max-width: 400px;
  width: 90%;
  box-shadow: var(--shadow-2);
  text-align: center;
}

.dialog-btn-group {
  display: flex;
  justify-content: center;
  gap: 1.25rem;
  margin-top: 1rem;
}

.dialog-btn-group button {
  padding: 0.5rem 1.2rem;
  border: none;
  border-radius: 5px;
  background-color: var(--clr-primary-6);
  color: white;
  font-weight: bold;
  cursor: pointer;
}
.dialog-btn-group button:hover {
  background-color: var(--clr-primary-7);
}

.timeline-cta-box {
  margin-top: 0.75rem;
}

.timeline-cta-text {
  font-size: 1rem;
  color: var(--clr-grey-2);
  font-weight: 500;
}

.timeline-cta-link {
  margin-left: 0.4rem;
  color: var(--clr-primary-6);
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}

.timeline-cta-link:hover {
  color: var(--clr-primary-4);
}
`, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/AdminDashboard.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,aAAa;IACb,wBAAwB;IACxB,cAAc;IACd,aAAa;IACb,4CAA4C;IAC5C,oCAAoC;IACpC,4BAA4B;IAC5B,+BAA+B;IAC/B,6BAA6B;IAC7B,sBAAsB;IACtB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA,YAAY;AACZ,sBAAsB;AACtB;IACI,eAAe;IACf,kCAAkC;IAClC,oBAAoB;IACpB,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,4BAA4B;AAC5B;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,kCAAkC;AAClC;IACI,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2CAA2C;AAC/C;;AAEA,kBAAkB;AAClB;IACI,iCAAiC;IACjC,wBAAwB;IACxB,oBAAoB;IACpB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI;QACI,WAAW;QACX,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA,mCAAmC;AACnC;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,sCAAsC;IACtC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,oCAAoC;IACpC,wBAAwB;IACxB,4BAA4B;IAC5B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,2BAA2B;AAC3B;;;GAGG;;AAEH;IACI,SAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;;AAGA,qBAAqB;AACrB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,mCAAmC;IACnC,uBAAuB;IACvB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,YAAY;IACZ,iCAAiC;IACjC,4BAA4B;IAC5B,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;;AAGA,gDAAgD;AAChD;IACI,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;IACvB,qDAAqD;IACrD,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA,iCAAiC;AACjC;IACI,kCAAkC;IAClC,eAAe;IACf,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;IACtC,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kCAAkC;AACtC;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;IACtC,eAAe;IACf,kCAAkC;AACtC;;;AAGA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,0BAA0B;AAC1B;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,4BAA4B;IAC5B,iBAAiB;IACjB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;AACA,wBAAwB;AACxB;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,aAAa;IACb,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,sBAAsB;EACtB;IACE,4BAA4B;IAC5B,oBAAoB;IACpB,4BAA4B;IAC5B,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;EAClC;;EAEA,UAAU;EACV;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,qBAAqB;EACvB;;EAEA,mBAAmB;EACnB;;IAEE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,qBAAqB;IACrB,eAAe;EACjB;;EAEA,qBAAqB;EACrB;IACE,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;EAClB;;EAEA,wBAAwB;AAC1B;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,2DAA2D;AAC7D;;AAEA,oBAAoB;AACpB;EACE,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;;EAEE,mBAAmB;EACnB;IACE,sCAAsC;IACtC,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;IACjC,aAAa;IACb,4BAA4B;IAC5B,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,cAAc;EACd;IACE;MACE,4BAA4B;MAC5B,UAAU;IACZ;IACA;MACE,0BAA0B;MAC1B,UAAU;IACZ;EACF;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;AAChC;IACI,qBAAqB;IACrB,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA,0BAA0B;EAC1B;IACE,aAAa;IACb,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB,EAAE,iCAAiC;IACpD,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,0DAA0D;AAC5D;EACE,gBAAgB;EAChB,wBAAwB;EACxB,wBAAwB;EACxB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,kCAAkC;EAClC,mCAAmC;EACnC,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;;EAEE,kCAAkC;EAClC,aAAa;AACf;;AAEA,oBAAoB;AACpB;IACI,sCAAsC;IACtC,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI;QACI,sBAAsB;QACtB,aAAa;IACjB;;;IAGA;QACI,SAAO;QACP,eAAe;QACf,qBAAqB;QACrB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA,oCAAoC;IACpC;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,mBAAmB;QACnB,eAAe;IACnB;;IAEA,gDAAgD;AACpD;IACI,eAAe;IACf,4BAA4B;IAC5B,uBAAuB;IACvB,qDAAqD;IACrD,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;IAEI,sBAAsB;IACtB;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ;;AAEA,wDAAwD;AACxD;IACI,8BAA8B,EAAE,wDAAwD;AAC5F;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,2CAA2C;EAC7C;;EAEA;IACE,UAAU,YAAY,EAAE;IACxB,MAAM,aAAa,EAAE;IACrB,YAAY,cAAc,EAAE;EAC9B;;;;EAIA,uDAAuD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA,qCAAqC;EACrC;IACE,SAAO;IACP,iCAAiC;IACjC,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;EAC7B;;EAEA,yCAAyC;EACzC;IACE,SAAO;IACP,iCAAiC;IACjC,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,mCAAmC;EACnC;IACE,kCAAkC;IAClC,iCAAiC;IACjC,8CAA8C,EAAE,6BAA6B;IAC7E,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;EAC/B;;EAEA;IACE,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,wBAAwB;EAC1B;;;EAGA;IACE,mBAAmB;IACnB,sCAAsC;IACtC,uBAAuB;IACvB,oBAAoB;IACpB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;;EAEA,qCAAqC;EACrC;IACE;MACE,sBAAsB;IACxB;;IAEA;;MAEE,WAAW;IACb;EACF;;EAEA;;;;;;;;KAQG;;;EAGH;IACE,sCAAsC;IACtC,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;AAEF;;EAEE,4CAA4C;EAC5C,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB,EAAE,sCAAsC;AAC9D;;AAEA,uDAAuD;AACvD;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0CAA0C;EAC1C,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,2CAA2C;AAC7C;;;AAGA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,wBAAwB;EACxB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;;AAGA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["/* Admin Dashboard Container */\n.admin-dashboard-container {\n    display: flex;\n    /* max-width: 1440px;  */\n    margin: 0 auto;\n    padding: 3rem; \n    /* background-color: var(--clr-primary-6); */\n    background-color: var(--clr-grey-10);\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    transition: var(--transition);\n    flex-direction: column; \n    animation: fadeIn 0.5s ease-in-out;\n    overflow: hidden; \n}\n\n/* Sidebar */\n/* Sidebar Container */\n.sidebar {\n    flex: 0 0 280px;\n    background-color: var(--clr-white);\n    padding: 1.5rem 1rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    margin-right: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    height: 100vh;\n    overflow-y: auto;\n}\n\n/* Sidebar Heading */\n.sidebar h3 {\n    font-size: 1.4rem;\n    font-weight: bold;\n    color: var(--clr-dark);\n    margin-bottom: 1rem;\n    text-align: center;\n    border-bottom: 2px solid var(--grey-200); \n    padding-bottom: 0.5rem;\n}\n\n/* Discipline Button */\n.discipline-button {\n    background-color: var(--clr-primary-2); \n    color: var(--clr-white);\n    padding: 0.75rem;\n    width: 100%;\n    border-radius: var(--radius);\n    font-size: 1.2rem;\n    font-weight: 600;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: var(--shadow-1);\n    margin-bottom: 0.4rem;\n    position: relative; \n}\n\n/* Selected Discipline */\n.discipline-button.selected {\n    background-color: var(--clr-primary-6); \n    color: var(--clr-white);\n    box-shadow: var(--shadow-2);\n}\n\n/* Discipline Button Hover */\n.discipline-button:hover {\n    background-color: var(--clr-primary-4);\n    transform: translateY(-2px);\n}\n\n/* Optional Indicator Arrow/Icon */\n.discipline-button::after {\n    content: '▸'; \n    font-size: 1.2rem;\n    color: var(--clr-white);\n    position: absolute;\n    right: 1rem;\n    transform: rotate(90deg);\n    transition: transform 0.3s ease;\n}\n\n/* Change arrow when selected */\n.discipline-button.selected::after {\n    transform: rotate(-90deg); \n}\n\n/* Doctor List */\n.doctor-list {\n    padding-left: 1.5rem;\n    margin-top: 0.4rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem; \n    border-left: 2px solid var(--clr-primary-4); \n}\n\n/* Doctor Button */\n.doctor-button {\n    background-color: var(--grey-100);\n    color: var(--clr-grey-1);\n    padding: 0.6rem 1rem;\n    border-radius: var(--radius);\n    font-size: 1rem;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: var(--shadow-1);\n    position: relative;\n}\n\n/* Hover Effect for Doctor */\n.doctor-button:hover {\n    background-color: var(--grey-300);\n    transform: translateX(5px); \n    box-shadow: var(--shadow-2);\n}\n\n/* Selected Doctor */\n.doctor-button.selected {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n    box-shadow: var(--shadow-2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .sidebar {\n        width: 100%;\n        margin-right: 0;\n        padding: 1rem;\n    }\n\n    .discipline-button, .doctor-button {\n        font-size: 1rem;\n    }\n}\n\n\n/* Flexibility for larger screens */\n@media (min-width: 768px) {\n    .admin-dashboard-container {\n        flex-direction: row; \n    }\n}\n\n/* Sidebar headings */\n.sidebar h3 {\n    font-size: 1.4rem;\n    font-weight: 600;\n    margin-bottom: 1rem;\n    color: var(--clr-grey-1);\n}\n\n.discipline-section {\n    margin-bottom: 1.5rem;\n}\n\n.discipline-button {\n    width: 100%;\n    padding: 0.75rem;\n    border: none;\n    border-radius: var(--radius);\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    cursor: pointer;\n    text-align: left;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: var(--transition);\n}\n\n.discipline-button:hover {\n    background-color: var(--clr-primary-3);\n    box-shadow: var(--shadow-3);\n}\n\n.doctor-list {\n    margin-top: 1rem;\n}\n\n.doctor-button {\n    display: block;\n    width: 100%;\n    padding: 0.5rem;\n    border: none;\n    background-color: var(--clr-grey-10);\n    color: var(--clr-grey-2);\n    border-radius: var(--radius);\n    margin-bottom: 0.5rem;\n    cursor: pointer;\n    text-align: left;\n    font-size: 1rem;\n    transition: var(--transition);\n}\n\n.doctor-button.selected {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n}\n\n.doctor-button:hover {\n    background-color: var(--clr-primary-6);\n    color: var(--clr-white);\n    box-shadow: var(--shadow-3);\n}\n\n/* Main Dashboard Section */\n/* .main-dashboard {\n    flex: 1;\n    padding-left: 20px;\n} */\n\n.main-dashboard {\n    flex: 1;\n    padding-left: 30px; \n    min-height: 100vh; \n    overflow-y: auto; \n}\n\n\n/* Controls Section */\n.admin-controls {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n}\n\n.admin-filter {\n    display: flex;\n    gap: 1rem;\n}\n\n.admin-filter button {\n    padding: 0.75rem 1.5rem;\n    border: none;\n    border-radius: var(--radius);\n    background-color: var(--clr-grey-3);\n    color: var(--clr-white);\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.admin-filter button.active {\n    background-color: var(--clr-primary-3);\n}\n\n.admin-filter button:hover {\n    background-color: var(--clr-primary-3);\n    transform: translateY(-2px);\n}\n\n/* Search Section */\n.admin-search input {\n    padding: 0.75rem;\n    width: 250px;\n    border: 1px solid var(--grey-300);\n    border-radius: var(--radius);\n    outline: none;\n    transition: var(--transition);\n}\n\n.admin-search input:focus {\n    border-color: var(--clr-primary-5);\n}\n\n/* Calendar Section */\n.admin-calendar {\n    background-color: #ffffff; \n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3); \n    padding: 2rem;\n    margin-bottom: 2rem;\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .admin-controls {\n        flex-direction: column; \n        align-items: stretch; \n        gap: 1rem;\n    }\n\n    .admin-filter {\n        flex-direction: column; \n        align-items: stretch; \n    }\n\n    .admin-filter button {\n        padding: 0.5rem 1rem; \n        font-size: 0.875rem; \n    }\n\n    .admin-search input {\n        width: 100%; \n        padding: 0.5rem;\n    }\n\n    .admin-calendar {\n        padding: 1rem; \n        margin-bottom: 1rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .admin-filter button {\n        padding: 0.5rem 0.75rem; \n        font-size: 0.75rem; \n    }\n\n    .admin-search input {\n        width: 100%; \n        padding: 0.5rem;\n    }\n\n    .admin-calendar {\n        padding: 0.75rem; \n    }\n}\n\n\n/* Calendar Event Buttons with Linear Gradient */\n.rbc-event {\n    padding: 0.5rem;\n    border-radius: var(--radius);\n    color: var(--clr-white);\n    background: linear-gradient(135deg, #48a9a6, #82b74b); \n    transition: var(--transition);\n    box-shadow: var(--shadow-2);\n}\n\n.rbc-event:hover {\n    transform: scale(1.05);\n    box-shadow: var(--shadow-3);\n}\n\n/* Admin Appointments Container */\n.admin-appointments-container {\n    background-color: var(--clr-white);\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    margin-top: 2rem;\n    position: relative;\n    flex-direction: column; \n}\n\n/* Container for search and sort */\n.search-sort-container {\n    display: flex; \n    align-items: center; \n    gap: 1rem; \n    margin-bottom: 1rem;\n}\n\n/* Search Section */\n.search-section input {\n    padding: 0.75rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--clr-primary-6);\n    width: 250px;\n    outline: none;\n}\n\n.search-section input:focus {\n    border-color: var(--clr-primary-5);\n}\n\n/* Sorting Section */\n.sort-section select {\n    padding: 0.75rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--clr-primary-6);\n    font-size: 1rem;\n    background-color: var(--clr-white);\n}\n\n\n/* Appointment List Styling */\n.admin-appointments-list {\n    max-height: 400px;\n    overflow-y: auto;\n    list-style: none;\n    padding: 1rem;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n/* List item styles */\n.admin-appointments-list li {\n    padding: 1.25rem;\n    background-color: var(--grey-100);\n    margin-bottom: 1rem;\n    border-radius: var(--radius);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: var(--shadow-1);\n    transition: var(--transition);\n    width: 100%;\n}\n\n.admin-appointments-list li:hover {\n    background-color: var(--grey-200);\n}\n\n/* Scrollbar styling */\n.admin-appointments-list::-webkit-scrollbar {\n    width: 8px;\n}\n\n.admin-appointments-list::-webkit-scrollbar-thumb {\n    background-color: var(--clr-primary-5);\n    border-radius: 4px;\n}\n\n.admin-appointments-list li strong {\n    font-size: 1.1rem;\n    color: var(--clr-grey-2);\n}\n\n/* No Appointments Found */\n.no-appointments {\n    text-align: center;\n    padding: 2rem;\n    font-size: 1.2rem;\n    color: var(--clr-grey-5);\n}\n\n/* Action Buttons */\n.admin-appointment-actions {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.approve-btn, .cancel-btn, .view-btn {\n    min-width: 100px;\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: var(--radius);\n    font-size: 0.9rem;\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.approve-btn {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n}\n\n.cancel-btn {\n    background-color: var(--red-dark);\n    color: var(--clr-white);\n}\n\n.view-btn {\n    background-color: var(--clr-primary-4);\n    color: var(--clr-white);\n}\n\n.approve-btn:hover {\n    background-color: var(--clr-primary-3);\n    transform: translateY(-2px);\n}\n\n.cancel-btn:hover {\n    background-color: var(--red-dark);\n    transform: translateY(-2px);\n}\n\n.view-btn:hover {\n    background-color: var(--clr-primary-2);\n    transform: translateY(-2px);\n}\n/* Pagination Controls */\n.pagination-controls {\n    display: flex;\n    justify-content: center;\n    margin-top: 1rem;\n}\n\n.pagination-controls button {\n    background-color: var(--grey-100);\n    border: none;\n    color: var(--grey-500);\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius);\n    cursor: pointer;\n    margin: 0 0.25rem;\n    transition: var(--transition);\n}\n\n.pagination-controls button:hover {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n}\n\n.pagination-controls button:disabled {\n    background-color: var(--grey-300);\n    cursor: not-allowed;\n}\n\n/* Modal Overlay */\n.modal-custom-admin {\n    position: fixed;\n    z-index: 1000;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* Modal Content Box */\n  .modal-content-custom-admin {\n    background: var(--clr-white);\n    padding: 2rem 2.5rem;\n    border-radius: var(--radius);\n    width: 800px;\n    max-width: 95%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n    animation: slideIn 0.3s ease-out;\n  }\n  \n  /* Title */\n  .modal-content-custom-admin h3 {\n    font-size: 1.5rem;\n    color: var(--clr-primary-4);\n    margin-bottom: 1.5rem;\n    text-align: center; \n  }\n  \n  /* Form Field Labels */\n  .modal-content-custom-admin label {\n    font-weight: 600;\n    color: var(--clr-grey-2);\n    display: block;\n    margin-bottom: 0.5rem;\n  }\n  \n  /* Dropdown & Fee */\n  .modal-content-custom-admin select,\n  .modal-content-custom-admin input {\n    width: 100%;\n    padding: 0.75rem;\n    border-radius: var(--radius);\n    border: 1px solid var(--grey-300);\n    margin-bottom: 1.5rem;\n    font-size: 1rem;\n  }\n  \n  /* Button Container */\n  .modal-btns-admin {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n  \n  /* Unified Button Base */\n.close-btn-admin,\n.view-intake-btn-admin {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  border-radius: var(--radius);\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n}\n\n/* Specific Styles */\n.close-btn-admin {\n  background-color: var(--grey-400);\n  color: var(--clr-white);\n}\n.close-btn-admin:hover {\n  background-color: var(--grey-500);\n}\n\n.view-intake-btn-admin {\n  background-color: var(--clr-primary-5);\n  color: var(--clr-grey-10);\n}\n.view-intake-btn-admin:hover {\n  background-color: var(--clr-primary-6);\n  transform: translateY(-1px);\n}\n.view-intake-btn-admin:active {\n  transform: scale(0.98);\n}\n\n  /* Confirm Button */\n  .confirm-payment-btn-admin {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    padding: 0.6rem 1.25rem;\n    border-radius: var(--radius);\n    font-size: 0.95rem;\n    cursor: pointer;\n  }\n  \n  .confirm-payment-btn-admin:hover {\n    background-color: var(--clr-primary-3);\n  }\n  \n  .payment-breakdown {\n    background-color: var(--grey-100);\n    padding: 1rem;\n    border-radius: var(--radius);\n    margin-bottom: 1.5rem;\n    border-left: 4px solid var(--clr-primary-5);\n    box-shadow: var(--shadow-1);\n  }\n  \n  .payment-breakdown p {\n    margin: 0.5rem 0;\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n  }\n  \n  .payment-breakdown strong {\n    color: var(--clr-grey-1);\n  }\n  \n  /* Animation */\n  @keyframes slideIn {\n    from {\n      transform: translateY(-30px);\n      opacity: 0;\n    }\n    to {\n      transform: translateY(0px);\n      opacity: 1;\n    }\n  }\n  \n  .invoice-preview-box-admin {\n    background-color: var(--grey-100);\n    padding: 1.25rem;\n    border-radius: var(--radius);\n    margin-top: 1rem;\n    margin-bottom: 1.5rem;\n    border-left: 4px solid var(--clr-primary-4);\n    box-shadow: var(--shadow-1);\n  }\n  \n  .invoice-preview-box-admin h4 {\n    margin-bottom: 1rem;\n    color: var(--clr-primary-4);\n    font-size: 1.1rem;\n    text-align: left;\n  }\n  \n  .invoice-summary-admin p {\n    margin: 0.4rem 0;\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n  }\n  \n  .invoice-summary-admin strong {\n    color: var(--clr-grey-1);\n  }\n  \n  /* Collapsible toggle button */\n.invoice-preview-toggle-btn {\n    display: inline-block;\n    background-color: var(--clr-primary-4);\n    color: var(--clr-white);\n    font-size: 0.95rem;\n    font-weight: 500;\n    padding: 0.5rem 1rem;\n    border-radius: var(--radius);\n    border: none;\n    cursor: pointer;\n    margin: 1rem 0;\n    transition: background-color 0.3s ease;\n  }\n  \n  .invoice-preview-toggle-btn:hover {\n    background-color: var(--clr-primary-5);\n  }\n  \n  /* Collapsible container */\n  .invoice-preview-collapsible {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.4s ease;\n  }\n  \n  .invoice-preview-collapsible.open {\n    max-height: 600px; /* enough space for the content */\n    overflow-y: auto;\n    margin-top: 1rem;\n  }\n\n  /* Matched input & dropdown styles inside InvoicePreview */\n.invoice-preview-box-admin label {\n  font-weight: 600;\n  margin: 0.5rem 0 0.25rem;\n  color: var(--clr-grey-1);\n  display: block;\n  font-size: 0.95rem;\n}\n\n.invoice-preview-box-admin input[type=\"text\"],\n.invoice-preview-box-admin select {\n  width: 100%;\n  padding: 0.45rem 0.75rem;\n  font-size: 0.95rem;\n  border: 1px solid var(--clr-grey-8);\n  border-radius: var(--radius);\n  background-color: var(--clr-white);\n  color: var(--clr-grey-1);\n  margin-bottom: 1rem;\n  transition: border-color 0.2s ease;\n}\n\n/* Style for react-select inside invoice box */\n.invoice-preview-box-admin .react-select__control {\n  width: 100%;\n  font-size: 0.95rem;\n  border-radius: var(--radius);\n  background-color: var(--clr-white);\n  border: 1px solid var(--clr-grey-8);\n  box-shadow: none;\n  transition: border-color 0.2s ease;\n  margin-bottom: 1rem;\n}\n\n.invoice-preview-box-admin .react-select__control--is-focused {\n  border-color: var(--clr-primary-5);\n  box-shadow: 0 0 0 1px var(--clr-primary-5);\n}\n\n.invoice-preview-box-admin .react-select__value-container {\n  padding: 0.25rem 0.5rem;\n}\n\n.invoice-preview-box-admin .react-select__input {\n  color: var(--clr-grey-1);\n}\n\n.invoice-preview-box-admin .react-select__menu {\n  font-size: 0.95rem;\n  z-index: 20;\n}\n\n.invoice-preview-box-admin .react-select__option {\n  padding: 0.5rem;\n}\n\n.invoice-preview-box-admin .react-select__option--is-focused {\n  background-color: var(--clr-primary-10);\n}\n\n.invoice-preview-box-admin .react-select__option--is-selected {\n  background-color: var(--clr-primary-5);\n  color: white;\n}\n\n.invoice-preview-box-admin input[type=\"text\"]:focus,\n.invoice-preview-box-admin select:focus {\n  border-color: var(--clr-primary-5);\n  outline: none;\n}\n\n/* Tooltip Styling */\n.react-tooltip {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 0.5rem;\n    border-radius: var(--radius);\n    font-size: 0.875rem;\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .admin-dashboard-container {\n        flex-direction: column;\n        padding: 1rem;\n    }\n\n\n    .sidebar {\n        flex: 1;\n        margin-right: 0;\n        margin-bottom: 1.5rem;\n        padding: 1rem;\n    }\n\n    .main-dashboard {\n        padding-left: 0;\n        width: 100%;\n    }\n\n    .admin-controls {\n        flex-direction: column;\n        gap: 1rem;\n    }\n\n    .admin-search input {\n        width: 100%;\n    }\n\n    .admin-appointments-list {\n        max-height: 300px;\n        padding: 1rem;\n        overflow-y: auto;\n    }\n\n    .admin-appointments-list li {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .admin-appointment-actions {\n        margin-top: 0.75rem;\n        width: 100%;\n        justify-content: flex-end;\n    }\n\n    .pagination-controls {\n        flex-direction: column;\n        align-items: center;\n        gap: 0.5rem;\n    }\n\n    .calendar-controls {\n        flex-direction: column;\n    }\n\n    /* Calendar adjustments for mobile */\n    .admin-calendar {\n        background-color: #ffffff; \n        box-shadow: var(--shadow-3);\n        margin-bottom: 2rem;\n        max-width: 100%;\n    }\n\n    /* Calendar Event Buttons with Linear Gradient */\n.rbc-event {\n    padding: 0.5rem;\n    border-radius: var(--radius);\n    color: var(--clr-white);\n    background: linear-gradient(135deg, #48a9a6, #82b74b); \n    transition: var(--transition);\n    box-shadow: var(--shadow-2);\n}\n\n.rbc-event:hover {\n    transform: scale(1.05);\n    box-shadow: var(--shadow-3);\n}\n\n    /* Modal adjustments */\n    .modal-content-custom {\n        width: 90%;\n        max-width: 350px;\n    }\n}\n\n/* Override the white-space: nowrap for .rbc-btn-group */\n.rbc-btn-group {\n    white-space: normal !important; /* Force normal white-space behavior to allow wrapping */\n}\n\n.loading-indicator {\n    text-align: center;\n    font-size: 1.2rem;\n    color: var(--clr-primary-5);\n    margin: 1rem 0;\n  }\n  \n  .loading-indicator::after {\n    content: '...';\n    animation: dots 1.5s steps(3, end) infinite;\n  }\n  \n  @keyframes dots {\n    0%, 20% { content: '.'; }\n    40% { content: '..'; }\n    60%, 100% { content: '...'; }\n  }\n  \n\n\n  /* Split the Required Action section into two columns */\n.admin-appointments-container.split-layout {\n    display: flex;\n    flex-direction: row;\n    gap: 2rem;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n  \n  /* Left Column: Booked Appointments */\n  .admin-appointments-list.booked-section {\n    flex: 1;\n    background-color: var(--grey-100);\n    border-radius: var(--radius);\n    padding: 1rem;\n    box-shadow: var(--shadow-1);\n  }\n  \n  /* Right Column: Completed Appointments */\n  .admin-appointments-list.completed-section {\n    flex: 1;\n    background-color: var(--grey-100);\n    border-radius: var(--radius);\n    padding: 1rem;\n    box-shadow: var(--shadow-1);\n    max-height: 400px;\n    overflow-y: auto;\n  }\n  \n  /* Card style for completed tasks */\n  .completed-card {\n    background-color: var(--clr-white);\n    border: 1px solid var(--grey-300);\n    border-left: 4px solid var(--clr-success-dark); /* Green left border for CO */\n    border-radius: var(--radius);\n    padding: 1rem;\n    margin-bottom: 1rem;\n    box-shadow: var(--shadow-1);\n    transition: var(--transition);\n  }\n  \n  .completed-card:hover {\n    background-color: var(--grey-200);\n    transform: translateY(-2px);\n  }\n  \n  .completed-card h4 {\n    margin-bottom: 0.5rem;\n    color: var(--clr-grey-1);\n  }\n  \n  .completed-card p {\n    margin-bottom: 0.75rem;\n    font-size: 1rem;\n    color: var(--clr-grey-1);\n  }\n  \n  \n  .confirm-payment-btn {\n    margin-top: 0.75rem;\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 0.5rem 1rem;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n  }\n  \n  .confirm-payment-btn:hover {\n    background-color: var(--clr-primary-3);\n  }\n  \n  /* Responsive fix: stack vertically */\n  @media (max-width: 1024px) {\n    .admin-appointments-container.split-layout {\n      flex-direction: column;\n    }\n  \n    .admin-appointments-list.booked-section,\n    .admin-appointments-list.completed-section {\n      width: 100%;\n    }\n  }\n  \n  /* .cancel-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n  \n  .approve-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  } */\n\n  \n  .download-invoice-btn-admin {\n    background-color: var(--clr-primary-4);\n    color: white;\n    padding: 0.6rem 1.25rem;\n    border: none;\n    border-radius: var(--radius);\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .download-invoice-btn-admin:hover {\n    background-color: var(--clr-primary-5);\n  }\n  \n.download-invoice-btn-admin:disabled,\n.confirm-payment-btn-admin:disabled {\n  background-color: var(--grey-300) !important;\n  color: var(--clr-grey-6) !important;\n  cursor: not-allowed !important;\n  opacity: 0.65;\n  box-shadow: none;\n  transform: none;\n  pointer-events: auto; /* So tooltips (if added) still work */\n}\n\n/* Optional: remove hover color changes when disabled */\n.download-invoice-btn-admin:disabled:hover,\n.confirm-payment-btn-admin:disabled:hover {\n  background-color: var(--grey-300) !important;\n}\n\n.invoice-hint-text {\n  font-size: 0.92rem;\n  color: #d97706; \n  margin: 0.5rem 0 0.75rem;\n  font-style: italic;\n}\n\n.corner-ribbon-v2 {\n  position: absolute;\n  top: 10px;\n  left: -35px;\n  width: 140px;\n  text-align: center;\n  background: linear-gradient(135deg, #ff6b6b, #ffa600); \n  color: white;\n  font-size: 0.8rem;\n  font-weight: 700;\n  padding: 6px 0;\n  transform: rotate(-45deg);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25); \n  z-index: 5;\n  pointer-events: none;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  border: 2px solid #fff3e0; \n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n\n.modal-content-custom-admin {\n  position: relative;\n  /* overflow: visible; */\n}\n\n.room-highlight {\n  display: inline-block;\n  background-color: #ffebee;  \n  color: #b71c1c;  \n  padding: 0.35rem 0.75rem;\n  border-left: 4px solid #e53935; \n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  margin: 0.4rem 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.insurance-hint-text {\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n  font-style: italic;\n  color: #d97706\n}\n\n\n.zero-insurance-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.zero-insurance-modal {\n  background: white;\n  padding: 2rem;\n  border-radius: 10px;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: var(--shadow-2);\n  text-align: center;\n}\n\n.dialog-btn-group {\n  display: flex;\n  justify-content: center;\n  gap: 1.25rem;\n  margin-top: 1rem;\n}\n\n.dialog-btn-group button {\n  padding: 0.5rem 1.2rem;\n  border: none;\n  border-radius: 5px;\n  background-color: var(--clr-primary-6);\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n}\n.dialog-btn-group button:hover {\n  background-color: var(--clr-primary-7);\n}\n\n.timeline-cta-box {\n  margin-top: 0.75rem;\n}\n\n.timeline-cta-text {\n  font-size: 1rem;\n  color: var(--clr-grey-2);\n  font-weight: 500;\n}\n\n.timeline-cta-link {\n  margin-left: 0.4rem;\n  color: var(--clr-primary-6);\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.timeline-cta-link:hover {\n  color: var(--clr-primary-4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
